// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1tlwl","info":"UpdateTermsInfo_info__Um4fY"};